// extracted by mini-css-extract-plugin
export default {"outer":"PageDisplay_outer__qsQuu","header":"PageDisplay_header__Xw8Q5","container":"PageDisplay_container__X7eEo","content":"PageDisplay_content__6li7g"};